import DefaultDialogController from 'utils/notifications/default-dialog-controller';

import template from './terms-preview-dialog.html';

class TermsPreviewDialogController extends DefaultDialogController {}

export default class TermsPreviewDialogComponent {
  constructor() {
    this.controller = TermsPreviewDialogController;
    this.template = template;
    this.bindings = {
      resolve: '<',
      close: '&',
      dismiss: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/terms/components/terms-preview-dialog/terms-preview-dialog-component.js